// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2ZlG5","requiredAsterisk":"Info_requiredAsterisk__2Q5gj"};